const config = {
  api: "https://api.e.report",
  // api: "http://ereport.dataon.cl:88",
  nxpage: 15,
};

module.exports = config;
